import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import ChatConversationLayer from "./ChatConversationLayer";


const ChatConversationPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                {/* Breadcrumb */}
                <Breadcrumb title="Components / Company Categories" />

                <ChatConversationLayer />

            </MasterLayout>
        </>
    );
};

export default ChatConversationPage;
